import { render, staticRenderFns } from "./DefaultPolicyList.vue?vue&type=template&id=217625ba"
import script from "./DefaultPolicyList.vue?vue&type=script&lang=js"
export * from "./DefaultPolicyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports